import NSSearchBar from 'bricks/NSSearchBar/NSSearchBar';
import React, { useState } from 'react';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';
import { NSButton } from 'bricks';
import { useGetAttributes } from 'components/DealForm/hooks/useGetAttributes';

export interface IProps {
    selectedColumns: string[];
    setSelectedColumns: (selectedColumns: string[]) => void;
}

const AddColumns = ({ selectedColumns, setSelectedColumns }: IProps) => {
    const [searchValue, setSearchValue] = useState<string>('');

    const { data: dealAttributes } = useGetAttributes();

    const filteredDealAttributes = dealAttributes?.filter(attribute => {
        const label = attribute.name;
        return label.toLocaleLowerCase().includes(searchValue.toLocaleLowerCase()) && !selectedColumns.includes(attribute.name);
    });

    const handleAddColumn = (columnName: string) => {
        if (!selectedColumns.includes(columnName)) {
            setSelectedColumns([...selectedColumns, columnName]);
        }
    };

    return (
        <div className="AddColumns d-flex flex-column">
            <p className="text-white my-2">Add columns:</p>
            <NSSearchBar
                containerClassName="mb-0"
                searchValue={searchValue || ''}
                placeholder="Search columns"
                handleChangeSearchValue={(event: React.ChangeEvent<HTMLInputElement>) => setSearchValue(event.target.value)}
                id="report-options"
            />
            <OverlayScrollbarsComponent
                defer
                options={{
                    scrollbars: { autoHide: 'leave' },
                    overflow: { y: 'scroll' },
                }}
                className="OverlayScrollbarsComponent overflow-auto"
            >
                {filteredDealAttributes?.map(attribute => (
                    <div key={attribute.name}>
                        <NSButton callback={() => handleAddColumn(attribute.name)} className="mt-2 py-2 w-100" color="secondary" outline={false}>
                            <div className="text-white d-flex justify-content-between align-items-center">
                                <h5 className="my-0">{attribute.name}</h5>
                            </div>
                        </NSButton>
                    </div>
                ))}
                {
                    dealAttributes && dealAttributes.length === selectedColumns.length
                        && <p className="text-muted text-center mt-2">All columns were added</p>
                }
            </OverlayScrollbarsComponent>
        </div>
    );
};

export default AddColumns;
